import {
  AppStateNotification,
  NEW_NOTIFICATION,
  NotificationActionTypes,
} from "./types";

const initialState: AppStateNotification = {
  notifications: [
    // {
    //   residentId: "34fed2a986744c7c85b0422da76ad7d9",
    //   type: AlertToken.CallButton,
    // },
  ],
};

const reducer = (
  state = initialState,
  action: NotificationActionTypes
): AppStateNotification => {
  switch (action.type) {
    case NEW_NOTIFICATION.NEW_NOTIFICATION_APPEARS:
      const notifNew = action.payload;

      return {
        ...state,
        notifications: [...state.notifications, notifNew],
      };

    case NEW_NOTIFICATION.NEW_NOTIFICATION_VIEW:
      const notifView = action.payload;
      const indexView = state.notifications.findIndex(
        (el) =>
          el.residentId === notifView.residentId &&
          el.type === notifView.type &&
          el?.datetime === notifView.datetime
      );
      if (indexView !== -1) {
        const newList = [...state.notifications];
        newList.splice(indexView, 1);
        return {
          ...state,
          notifications: newList.concat([notifView]),
        };
      }
      return state;
    case NEW_NOTIFICATION.NEW_NOTIFICATION_VIEW_FEEDBACK:
      const notifFeed = action.payload;
      const indexFeed = state.notifications.findIndex(
        (el) =>
          el.residentId === notifFeed.residentId &&
          el.type === notifFeed.type &&
          el?.datetime === notifFeed.datetime
      );
      if (indexFeed !== -1) {
        const newList = [...state.notifications];
        newList.splice(indexFeed, 1);
        return {
          ...state,
          notifications: newList.concat([notifFeed]),
        };
      }
      return state;
    case NEW_NOTIFICATION.NEW_NOTIFICATION_CONGRAT:
      const notif = action.payload;

      return {
        ...state,
        notifications: [...state.notifications, notif],
      };

    case NEW_NOTIFICATION.NEW_NOTIFICATION_CLEAR:
      const notifClear = action.payload;
      const index = state.notifications.findIndex(
        (el) =>
          el.residentId === notifClear.residentId && el.type === notifClear.type
      );
      if (index !== -1) {
        const newList = [...state.notifications];
        newList.splice(index, 1);
        return {
          ...state,
          notifications: newList,
        };
      }
      return state;
    case NEW_NOTIFICATION.NEW_NOTIFICATION_CONFIRM:
      return {
        ...state,
        notifications: [...state.notifications, action.payload],
      };
    default:
      return state;
  }
};

export default reducer;
